module.exports = __webpack_public_path__ + "img/services-icon-2.f038ecf0.png";